module.exports = __webpack_public_path__ + "img/stripe.be10f604.svg";